/**
 * Created by jacmai on 3/8/2017.
 */
define([
  "marionette",
  "messaging/messenger",
  "modules/actions/actionGroup/actionGroupItems/actionGroupItemsView",
  "modules/actions/actionGroup/actionItemModal/actionItemModalModule",
], function (Marionette, Messenger, ActionGroupItemsView, ActionItemModalModule) {
  var ActionGroupItemsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "actiongroupitems";
      this.region = options.region;
    },
    show: function (actionGroup) {
      var apis = Messenger.reqres.request("action:apis");
      var variables = Messenger.reqres.request("action:all:variables");
      apis.onSynced(function () {
        variables.onSynced(function () {
          this.view = new ActionGroupItemsView.actionGroupItemsView({
            collection: actionGroup.actionItems(),
            apis: apis,
            variables: variables,
          });

          this.view.on(
            "add:item",
            function () {
              //pass the modal the collection of action items
              var modalBundle = {
                actionItems: actionGroup.actionItems(),
              };
              Messenger.vent.trigger(
                "show:modal",
                ActionItemModalModule,
                {
                  editMode: false,
                },
                modalBundle,
                {
                  title: "actions.items.addAction",
                  closeOnBackgroundClick: false,
                  modalWidth: 1000,
                  trackInteraction: {
                    action: "Add Action",
                    object: "Action",
                  },
                },
              );
            },
            this,
          );

          this.view.on(
            "itemview:edit:item",
            function (childView) {
              //pass the modal the collection of action items and the item to edit
              var modalBundle = {
                actionItems: actionGroup.actionItems(),
                item: childView.model,
              };
              Messenger.vent.trigger(
                "show:modal",
                ActionItemModalModule,
                {
                  editMode: true,
                },
                modalBundle,
                {
                  title: "actions.items.editAction",
                  closeOnBackgroundClick: false,
                  modalWidth: 1000,
                  trackInteraction: {
                    action: "Edit Action",
                    id: modalBundle.id,
                    idType: "Action",
                    object: "Action",
                  },
                },
              );
            },
            this,
          );

          this.view.on(
            "itemview:delete:item",
            function (childView) {
              Messenger.yesNoDialog(
                "actions.items.dialog.delete",
                {
                  yes: function () {
                    Messenger.vent.trigger("track:interaction", {
                      action: "Delete Action",
                      id: childView.model.id,
                      idType: "Action",
                      object: "Action",
                      source: "Actions List",
                    });
                    childView.model.deleteModel();
                  },
                },
                this,
              );
            },
            this,
          );

          this.showRegion(this.view, { loading: true });
        }, this);
      }, this);
    },
  });

  return ActionGroupItemsController;
});
